import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type HeaderOutlinedFieldSize = 'small' | 'medium';

/**
 * Outlined control visuals aligned with header date fields (`MuiPickersOutlinedInput`
 * overrides on `MuiTextField` in theme) so Autocomplete-style inputs match
 * `DateRange` / `SingleDate` next to filter actions in the page header.
 */
export function headerOutlinedFieldStyles(
  theme: Theme,
  inputSize: HeaderOutlinedFieldSize,
): SystemStyleObject<Theme> {
  const primary = theme.palette.primary.main;
  const background = theme.palette.background.paper;
  const padding = inputSize === 'small' ? '4px 10px' : '9px 16px';

  return {
    '& .MuiOutlinedInput-root': {
      border: `0.5px solid ${primary}`,
      background: background,
      transition: theme.transitions.create(['border-color', 'box-shadow'], {
        duration: theme.transitions.duration.short,
      }),
      padding: padding,
    },
    '& .MuiPickersInputBase-root': {
      border: `0.5px solid ${primary}`,
      color: `${primary} !important`,
    },
    '& .MuiPickersInputBase-root .MuiInputBase-input': {
      // border: `0.5px solid ${primary}`,
      color: `${primary} !important`,
    },
    '& .MuiPickersInputBase-root .MuiSvgIcon-root': {
      color: `${primary} !important`,
    },
    '& .MuiAutocomplete-endAdornment': {
      display: 'flex',
      alignItems: 'center',
      top: '50% !important',
      transform: 'translateY(-50%)',
    },
  };
}
